export const LITTERATURE_VARIANTS = [
  'article',
  'book',
  'journal',
  'author',
] as const

export type LitteratureVariant = typeof LITTERATURE_VARIANTS[number]

export const LITERATURE_SORTING_OPTIONS = [
  {
    value: 'kronologisk',
    label: 'Kronologisk',
  },
  {
    value: 'forfatter',
    label: 'Forfatter',
  },
  {
    value: 'tittel',
    label: 'Tittel',
  },
] as const

export const JOURNAL_SORTING_OPTIONS = [
  {
    value: 'alfabetisk',
    label: 'Alfabetisk',
  },
  {
    value: 'kronologisk',
    label: 'Kronologisk',
  },
] as const
